<template>
  <div>
    <div class="box box-active">
      <div class="px-6 py-4 flex items-center">
        <h3 class="font-semibold"><span class="hidden md:block">お困りではありませんか？</span><span class="md:hidden">お困りですか？</span></h3>
        <div class="ml-auto cursor-pointer" @click="close">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.1719 6.42187C19.6125 5.98124 19.6125 5.26874 19.1719 4.83281C18.7313 4.39687 18.0188 4.39218 17.5828 4.83281L12.0047 10.4109L6.4219 4.82812C5.98127 4.38749 5.26877 4.38749 4.83284 4.82812C4.3969 5.26874 4.39221 5.98124 4.83284 6.41718L10.411 11.9953L4.82815 17.5781C4.38752 18.0187 4.38752 18.7312 4.82815 19.1672C5.26877 19.6031 5.98127 19.6078 6.41721 19.1672L11.9953 13.5891L17.5781 19.1719C18.0188 19.6125 18.7313 19.6125 19.1672 19.1719C19.6031 18.7312 19.6078 18.0187 19.1672 17.5828L13.5891 12.0047L19.1719 6.42187Z" fill="#333333"/>
          </svg>
        </div>
      </div>
      <div class="hidden md:block">
        <div class="px-6 pt-4 pb-8">
          <p class="text-sm leading-tight">預けたい荷物についてお聞かせください。WareXが条件に合った倉庫を提案します。</p>
          <div class="mt-4">
            <nuxt-link  to="/user-contact" class="flex items-center justify-center h-10 bg-secondary text-white rounded-full" href="">WareXに相談する（無料）</nuxt-link>
          </div>
        </div>
      </div>
      <div class="md:hidden">
        <div class="px-6 pt-4 pb-6 flex flex-col items-center justify-center bg-black text-white relative">
          <div class="bg" />
          <div class="relative">
            <p class="text-sm leading-tight">WareXが条件に合った倉庫を提案します。</p>
            <div class="mt-4">
              <nuxt-link  to="/user-contact" class="flex items-center justify-center h-10 bg-secondary text-white rounded-full text-xs" href="">WareXに相談する（無料）</nuxt-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box box-inactive hidden lg:block">
      <div class="px-6 py-4 flex items-center">
        <h3 class="font-semibold"><span class="hidden md:block">お困りではありませんか？</span><span class="md:hidden">お困りですか？</span></h3>
        <div class="ml-auto cursor-pointer" @click="open">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.2031 5.20315C11.6437 4.76252 12.3562 4.76252 12.7922 5.20315L21.7969 14.2032C22.2375 14.6438 22.2375 15.3563 21.7969 15.7922C21.3562 16.2282 20.6437 16.2328 20.2078 15.7922L12.0047 7.58909L3.79687 15.7969C3.35624 16.2375 2.64374 16.2375 2.2078 15.7969C1.77187 15.3563 1.76718 14.6438 2.2078 14.2078L11.2031 5.20315Z" fill="#333333"/>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
.bg
  @apply absolute inset-0 bg-cover
  opacity: .65
  background-position: center top
  background-image: url(~@/assets/img/index/main_bg.jpg)
.box
  width: 232px
  @apply bg-white rounded-lg overflow-hidden fixed right-0 bottom-0 m-4 mb-20
  z-index: 13 // higher than search results 10, lower than mobile menu 20
  box-shadow: 0 0 4px 0 rgba(0,0,0,.25)
  transition: transform 0.5s
  @screen md
    width: 336px
    @apply mr-8
  @screen lg
    @apply m-8
.box-active
  transform: translateY(200%)
  .open &
    transform: none
.box-inactive
  transform: translateY(200%)
  .close &
    transform: none
</style>

<script>
export default {
  data() {
    return {
      timeout: undefined,
      closed: 0,
    }
  },
  mounted() {
    this.closed = globalThis.sessionStorage.getItem('closed_popup_in_warehouse_list') || 0
    this.timeout = globalThis.setTimeout(() => {
      this.$el.classList.add(this.closed ? 'close' : 'open')
    }, 5000)
  },
  beforeDestroy() {
    globalThis.clearTimeout(this.timeout)
  },
  methods: {
    open() {
      this.$el.classList.add('open')
      this.$el.classList.remove('close')
    },
    close() {
      this.$el.classList.remove('open')
      this.$el.classList.add('close')
      globalThis.sessionStorage.setItem('closed_popup_in_warehouse_list', 1)
    }
  }
}
</script>